document.addEventListener('DOMContentLoaded', function() {
  function triggerConfetti() {
    const duration = 2 * 1000,
      animationEnd = Date.now() + duration,
      defaults = { 
        startVelocity: 30, 
        spread: 360, 
        ticks: 60, 
        zIndex: 1000,
        shapes: ["triangle"],
        colors: ["#00b7e2", "#711099", "#ffffff", "#ffd700"],
      };

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    const interval = setInterval(function() {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / duration);

      confetti(
        Object.assign({}, defaults, {
          particleCount,
          scalar: 2,
          origin: { x: randomInRange(0, 1), y: 0 },
        })
      );

      confetti(
        Object.assign({}, defaults, {
          particleCount,
          scalar: 2,
          origin: { x: 0, y: randomInRange(0, 0.5) },
        })
      );

      confetti(
        Object.assign({}, defaults, {
          particleCount,
          scalar: 2,
          origin: { x: 1, y: randomInRange(0, 0.5) },
        })
      );
    }, 250);
  }

  // Trigger confetti on page load
  triggerConfetti();

  // Also trigger confetti when button is clicked
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-action="trigger-confetti"]')) {
      e.preventDefault();
      triggerConfetti();
    }
  });
});
